import React from 'react';
import cn from '../../lib/bem/index';
import { Tooltip } from 'react-tooltip'
import ico_information from './../../assets/svg/ico_information.svg';

import './tooltip_component.scss';

const TooltipComponent = (props) => {

    const classes = cn("tooltipComponent");

    return (
        <div className={classes()}> 
            {
                !props.disable ? 
                    <div>
                        <img src={ico_information} alt="ico_information" data-tooltip-id={props.id}/>
                        <Tooltip
                            id={props.id}
                            place='right'
                            variant='light'
                            border="1px solid #0099CC"
                        >  
                            <p style={{width:'250px',textAlign:'center'}} >{props.text}</p>
                        </Tooltip>
                    </div> : null 
            }
            
        </div>
    );
};

export default TooltipComponent;